/* eslint-disable import/prefer-default-export */
export const nameValueReducer = (items, item) => {
  items[item.Name] = item.Value;
  return items;
};

export const overspeedsSums = (statsBy={}) =>
  // eslint-disable-next-line object-curly-newline
  Object.values(statsBy).reduce((res, { noOverSpeed = 0, small = 0, medium = 0, large = 0, xlarge = 0 }) =>
    ({
      noOverSpeed: res.noOverSpeed + noOverSpeed,
      small: res.small + small,
      medium: res.medium + medium,
      large: res.large + large,
      xlarge: res.xlarge + xlarge,
    }), {
    noOverSpeed: 0, small: 0, medium: 0, large: 0, xlarge: 0,
  });



// WEBPACK FOOTER //
// ./src/utils/reducers.js